import { createAction } from 'redux-actions'
import _ from 'underscore'
import api from '../services/api'
import { notify } from '../services/helpers'
import $ from 'jquery'
import { removeLogoUrls } from '../services/helpers'

const PREFIX = 'Integrations.'

export const FETCH_CANDIDATES_DATA_INIT = PREFIX + 'FETCH_CANDIDATES_DATA_INIT'
const fetchCandidatesDataInit = createAction(FETCH_CANDIDATES_DATA_INIT)

export const FETCH_CANDIDATES_DATA_DONE = PREFIX + 'FETCH_CANDIDATES_DATA_DONE'
const fetchCandidatesDataDone = createAction(FETCH_CANDIDATES_DATA_DONE)

export const FETCH_CANDIDATES_DATA_FAIL = PREFIX + 'FETCH_CANDIDATES_DATA_FAIL'
const fetchCandidatesDataFail = createAction(FETCH_CANDIDATES_DATA_FAIL)

export function fetchCandidatesData() {
  return (dispatch, getState) => {
    const { authToken } = getState()

    if (!authToken) {
      return
    }

    dispatch(fetchCandidatesDataInit())
    return api
      .service('bullhorn')
      .post('candidates?include_file_attachments=false', {
        session_token: authToken,
      })
      .done((response) => {
        dispatch(fetchCandidatesDataDone(response))
      })
      .fail((err) => {
        dispatch(fetchCandidatesDataFail())
      })
  }
}

export const FETCH_RESUMES_DATA_INIT = PREFIX + 'FETCH_RESUMES_DATA_INIT'
const fetchResumesDataInit = createAction(FETCH_RESUMES_DATA_INIT)

export const FETCH_RESUMES_DATA_DONE = PREFIX + 'FETCH_RESUMES_DATA_DONE'
const fetchResumesDataDone = createAction(FETCH_RESUMES_DATA_DONE)

export const FETCH_RESUMES_DATA_FAIL = PREFIX + 'FETCH_RESUMES_DATA_FAIL'
const fetchResumesDataFail = createAction(FETCH_RESUMES_DATA_FAIL)

export function fetchResumesData(page = 1, query = null, sortByDate = null) {
  return (dispatch, getState) => {
    const { authToken, activeCandidateId } = getState()

    if (!authToken) {
      return
    }

    dispatch(fetchResumesDataInit())

    let payload = {
      session_token: authToken,
      per_page: 10,
      page,
    }
    if (activeCandidateId) {
      payload['candidate_id'] = activeCandidateId
    }
    if (query) {
      payload['search_query'] = query
    }
    if (sortByDate) {
      payload['sort_by_date'] = sortByDate
    }

    return api
      .service('bullhorn')
      .post('editor/conversions', payload)
      .done((response) => {
        dispatch(fetchResumesDataDone(response))
        dispatch(setCurrentPage('resume_listing'))
      })
      .fail((err) => {
        notify('Fetching conversions data failed', 'error')
        dispatch(fetchResumesDataFail())
      })
  }
}

export const FETCH_TEMPLATES_DATA_INIT = PREFIX + 'FETCH_TEMPLATES_DATA_INIT'
const fetchTemplatesDataInit = createAction(FETCH_TEMPLATES_DATA_INIT)

export const FETCH_TEMPLATES_DATA_DONE = PREFIX + 'FETCH_TEMPLATES_DATA_DONE'
const fetchTemplatesDataDone = createAction(FETCH_TEMPLATES_DATA_DONE)

export const FETCH_TEMPLATES_DATA_FAIL = PREFIX + 'FETCH_TEMPLATES_DATA_FAIL'
const fetchTemplatesDataFail = createAction(FETCH_RESUMES_DATA_FAIL)

export function fetchTemplatesData() {
  return (dispatch, getState) => {
    const { authToken } = getState()

    if (!authToken) {
      return
    }

    dispatch(fetchTemplatesDataInit())
    return api
      .service('bullhorn')
      .post('editor/templates', {
        session_token: authToken,
      })
      .done((response) => {
        dispatch(fetchTemplatesDataDone(response))
      })
      .fail((err) => {
        dispatch(fetchTemplatesDataFail())
      })
  }
}

export const CONVERT_RESUMES_INIT = PREFIX + 'CONVERT_RESUMES_INIT'
const convertResumesInit = createAction(CONVERT_RESUMES_INIT)

export const CONVERT_RESUMES_DONE = PREFIX + 'CONVERT_RESUMES_DONE'
const convertResumesDone = createAction(CONVERT_RESUMES_DONE)

export const CONVERT_RESUMES_FAIL = PREFIX + 'CONVERT_RESUMES_FAIL'
const convertResumesFail = createAction(CONVERT_RESUMES_FAIL)

export function convertResumes(data) {
  return (dispatch, getState) => {
    const { authToken } = getState()

    if (!authToken) {
      return
    }

    let candidates = []
    data.forEach((candidate) => {
      candidates.push({
        candidate_id: candidate['id'],
        file_attachment_id: candidate['file_attachment_id'],
        template_id: candidate['template_id'],
        filename: candidate['filename'],
        target_filename: candidate['target_filename']
          ? candidate['target_filename']
          : candidate['defaultTargetFileName']
          ? candidate['defaultTargetFileName']
          : '',
      })
    })

    dispatch(convertResumesInit())
    return api
      .service('bullhorn')
      .post('editor/templates/convert', {
        candidates: JSON.stringify(candidates),
        session_token: authToken,
      })
      .done((response) => {
        dispatch(convertResumesDone())
        dispatch(fetchResumesData())
        notify(
          `${data.length} resume(s) successfully shared for conversion`,
          'success'
        )
      })
      .fail((err) => {
        notify('Conversion request failed', 'error')
        dispatch(convertResumesFail())
      })
  }
}

export const FETCH_CANDIDATE_ATTACHMENTS_INIT = PREFIX + 'FETCH_CANDIDATE_ATTACHMENTS_INIT'
const getCandidateAttachmentsInit = createAction(FETCH_CANDIDATE_ATTACHMENTS_INIT)

export const FETCH_CANDIDATE_ATTACHMENTS_DONE = PREFIX + 'FETCH_CANDIDATE_ATTACHMENTS_DONE'
const getCandidateAttachmentsDone = createAction(FETCH_CANDIDATE_ATTACHMENTS_DONE)

export const FETCH_CANDIDATE_ATTACHMENTS_FAIL = PREFIX + 'FETCH_CANDIDATE_ATTACHMENTS_FAIL'
const getCandidateAttachmentsFail = createAction(FETCH_CANDIDATE_ATTACHMENTS_FAIL)

export function getCandidateAttachments(candidateId, fileId, templateId) {
  return (dispatch, getState) => {
    const { authToken } = getState()

    if (!authToken) {
      return
    }

    dispatch(getCandidateAttachmentsInit(candidateId, fileId, templateId))
    return api
      .service('bullhorn')
      .post('candidates/attachments', {
        candidate_id: candidateId,
        session_token: authToken,
      })
      .done((response) => {
        dispatch(getCandidateAttachmentsDone({ candidateId, data: response.data, fileId, templateId }))
      })
      .fail((err) => {
        notify('Error fetching file attachments', 'error')
        dispatch(getCandidateAttachmentsFail(candidateId, fileId, templateId))
      })
  }
}

export function downloadOutputResume(resume_id, type) {
  return (dispatch, getState) => {
    const { authToken } = getState()

    if (!authToken) {
      return
    }

    return api
      .service('bullhorn')
      .post(`editor/conversion/${resume_id}/targetFile`, {
        session_token: authToken,
        file_type: type
      })
      .done(function (response) {
        const { file_url } = response
        if (file_url) {
          window.open(file_url, '_blank')
        }
      })
      .fail(function (xhr) {})
  }
}

export function reportConversionError(resume_id) {
  return (dispatch, getState) => {
    const { authToken } = getState()

    if (!authToken) {
      return
    }

    return api
      .service('bullhorn')
      .put(`editor/conversion/${resume_id}/reportError`, {
        session_token: authToken,
      })
      .done(function (response) {
        notify('Reported successfully', 'success')
      })
      .fail(function (xhr) {})
  }
}

export const UPDATE_CANDIDATE_TARGET_FILE_NAME = PREFIX + 'UPDATE_CANDIDATE_TARGET_FILE_NAME'
export const updateCandidateTargetFileName = createAction(UPDATE_CANDIDATE_TARGET_FILE_NAME)

export const SET_CURRENT_PAGE_DONE = PREFIX + 'SET_CURRENT_PAGE_DONE'
export const setCurrentPage = createAction(SET_CURRENT_PAGE_DONE)

export const SET_AUTH_TOKEN_DONE = PREFIX + 'SET_AUTH_TOKEN_DONE'
export const setAuthToken = createAction(SET_AUTH_TOKEN_DONE)

export const SET_ACTIVE_CANDIDATE_ID_DONE = PREFIX + 'SET_ACTIVE_CANDIDATE_ID_DONE'
export const setActiveCandidateId = createAction(SET_ACTIVE_CANDIDATE_ID_DONE)

export const TOGGLE_CANDIDATE_DETAILS_MODAL = PREFIX + 'TOGGLE_CANDIDATE_DETAILS_MODAL'
const toggleCandidateDetailsModalDone = createAction(TOGGLE_CANDIDATE_DETAILS_MODAL)

export function toggleCandidateDetailsModal(input) {
  return (dispatch, getState) => {
    dispatch(toggleCandidateDetailsModalDone(input))
  }
}

export const TOGGLE_DUPLICATE_RESUME_WARNING_MODAL = PREFIX + 'TOGGLE_DUPLICATE_RESUME_WARNING_MODAL'
const toggleDuplicateResumeWarningModalDone = createAction(TOGGLE_DUPLICATE_RESUME_WARNING_MODAL)

export function toggleDuplicateResumeWarningModal(input) {
  return (dispatch, getState) => {
    dispatch(toggleDuplicateResumeWarningModalDone(input))
  }
}

export const FETCH_TEMPLATE_CONFIGURATIONS_DONE = PREFIX + 'FETCH_TEMPLATE_CONFIGURATIONS_DONE'
const fetchTemplateConfigurationsDone = createAction(FETCH_TEMPLATE_CONFIGURATIONS_DONE)

export const SET_CANDIDATE_MAPPING_DATA_DONE = PREFIX + 'SET_CANDIDATE_MAPPING_DATA_DONE'
const setCandidateMappingDataDone = createAction(SET_CANDIDATE_MAPPING_DATA_DONE)

export function fetchTemplateConfigurations() {
  return (dispatch, getState) => {
    const { authToken } = getState()
    if (!authToken) {
      return
    }
    return api
      .service('bullhorn')
      .get('template-configurations', {
        session_token: authToken,
      })
      .done((response) => {
        dispatch(fetchTemplateConfigurationsDone(response))
        dispatch(setCandidateMappingDataDone(response))
      })
      .fail((err) => {
        console.log(err)
      })
  }
}

export const FETCH_CANDIDATE_DETAILS_INIT = PREFIX + 'FETCH_CANDIDATE_DETAILS_INIT'
const fetchCandidateDetailsInit = createAction(FETCH_CANDIDATE_DETAILS_INIT)

export const FETCH_CANDIDATE_DETAILS_DONE = PREFIX + 'FETCH_CANDIDATE_DETAILS_DONE'
const fetchCandidateDetailsDone = createAction(FETCH_CANDIDATE_DETAILS_DONE)

export const FETCH_CANDIDATE_DETAILS_FAIL = PREFIX + 'FETCH_CANDIDATE_DETAILS_FAIL'
const fetchCandidateDetailsFail= createAction(FETCH_CANDIDATE_DETAILS_FAIL)

export function fetchCandidateDetails(resumeId) {
  return (dispatch, getState) => {
    const { authToken } = getState()
    if (!authToken) {
      return
    }
    dispatch(fetchCandidateDetailsInit())
    return api
      .service('bullhorn')
      .get('verification-params', {
        id: resumeId,
        session_token: authToken,
      })
      .done((response) => {
        dispatch(fetchCandidateDetailsDone({ data: response, resumeId }))
      })
      .fail((err) => {
          dispatch(fetchCandidateDetailsFail())
          notify('Error in fetching candidate details', 'error')
          dispatch(toggleCandidateDetailsModal({ isOpen: false, resumeId: null }))
      })
  }
}

export function callResumeDuplicate(resumeId, builderId) {
  return (dispatch, getState) => {
    const { authToken } = getState()
    if (!authToken) {
      return
    }
    dispatch(fetchCandidateDetailsInit())
    return api
      .service('bullhorn')
      .post('duplicate', {
        id: resumeId,
        session_token: authToken,
      })
      .done((response) => {
        dispatch(fetchResumesData())
        dispatch(
          toggleCandidateDetailsModal({
            isOpen: true,
            resumeId: response.id,
            builderId: builderId,
            showEditText: true,
          })
        )
      })
      .fail((err) => {
          notify('Error in duplicating resume', 'error')
      })
  }
}

export function updateCandidateDetails(resumeId, data, save = false) {
  return (dispatch, getState) => {
    const { authToken } = getState()
    if (!authToken) {
      return
    }
    return api
      .service('bullhorn')
      .put('verification-params', {
        id: resumeId,
        params: removeLogoUrls(data),
        session_token: authToken,
        only_save: save,
      })
      .done((response) => {
        if (!save) dispatch(fetchResumesData())
      })
      .fail((err) => {
          notify('Error in details verification', 'error')
      })
  }
}

export const RE_GENERATE_SUMMARY_INIT = PREFIX + 'RE_GENERATE_SUMMARY_INIT'
const reGenerateSummaryInit = createAction(RE_GENERATE_SUMMARY_INIT)

export const RE_GENERATE_SUMMARY_DONE = PREFIX + 'RE_GENERATE_SUMMARY_DONE'
const reGenerateSummaryDone = createAction(RE_GENERATE_SUMMARY_DONE)

export const RE_GENERATE_SUMMARY_FAIL = PREFIX + 'RE_GENERATE_SUMMARY_FAIL'
const reGenerateSummaryFail= createAction(RE_GENERATE_SUMMARY_FAIL)

export function reGenerateSummary(resumeId, text, newText) {
  return (dispatch, getState) => {
    const { authToken } = getState()
    if (!authToken) {
      return
    }
    dispatch(reGenerateSummaryInit())
    return api
      .service('bullhorn')
      .post('regenerate-summary', {
        id: resumeId,
        input_text: text,
        user_input: newText,
        session_token: authToken,
      })
      .done((response) => {
        dispatch(reGenerateSummaryDone(response))
      })
      .fail((err) => {
        dispatch(reGenerateSummaryFail())
      })
  }
}

export const UPDATE_LOGO_INIT = PREFIX + 'UPDATE_LOGO_INIT'
const updateLogoInit = createAction(UPDATE_LOGO_INIT)

export const UPDATE_LOGO_DONE = PREFIX + 'UPDATE_LOGO_DONE'
const updateLogoDone = createAction(UPDATE_LOGO_DONE)

export const DELETE_LOGO_DONE = PREFIX + 'DELETE_LOGO_DONE'
const deleteLogoDone = createAction(DELETE_LOGO_DONE)

export const UPDATE_LOGO_FAIL = PREFIX + 'UPDATE_LOGO_FAIL'
const updateLogoFail = createAction(UPDATE_LOGO_FAIL)

export const TOGGLE_LOGO_DELETE_MODAL = PREFIX + 'TOGGLE_LOGO_DELETE_MODAL'
export const toggleLogoDeleteModal = createAction(TOGGLE_LOGO_DELETE_MODAL)

export function updateLogo(data, picture, company) {
  let pictureSize = null
  if (picture && picture.files && picture.files[0]) {
    pictureSize = picture.files[0].size
  }
  return (dispatch, getState) => {
    const { authToken } = getState()
    if (!authToken) {
      return
    }
    if (!pictureSize || pictureSize > 2 * 100 * 1000) {
      notify('Failed to upload logo. Please upload a logo having size less than 200 KB.', 'error')
      return
    }
    let form_data = new FormData()
    for (let key in data) {
      form_data.append(key, data[key])
    }
    dispatch(updateLogoInit(company))
    return api
      .service('bullhorn')
      .post('upload-logo', form_data, {
        processData: false,
        contentType: false,
      })
      .done(response => {
        dispatch(updateLogoDone({ response, company }))
        notify('Uploaded logo successfully')
      })
      .fail(xhr => {
        dispatch(updateLogoFail(company))
        notify('Failed to upload logo. Please upload a logo having size less than 200 KB.', 'error')
      })
  }
}

export function deleteCompanyLogo(resumeId, company) {  
  return (dispatch, getState) => {
    const { authToken } = getState()
    if (!authToken) {
      return
    }
    dispatch(updateLogoInit(company))
    let params = {
      id: resumeId,
      'field': 'company',
      'field-entity': company,
      session_token: authToken,
    }
    return api
      .service('bullhorn')
      .delete('delete-logo', params)
      .done(function (response) {
        dispatch(deleteLogoDone({ company }))
        notify('Deleted logo successfully')
      })
      .fail(function (xhr) {
        dispatch(updateLogoFail(company))
        notify('Failed to remove logo.', 'error')
      })
  }
}